const hotpotpalace = ["#ffd258", "#ffd2583d", "#ffd258", "#ffffff"];
const hkyuebaby = ["#ffd258", "#ffd2583d", "#ffd258", "#ffffff"];
const jiaojiaoxiaoyu = ["#ffd258", "#ffd2583d", "#ffd258", "#ffffff"];
const dolarshopsydney = ["#A98D68", "#A98D683d", "#A98D68", "#ffffff"];
const jackpothotpot = ["#A98D68", "#A98D683d", "#A98D68", "#ffffff"];
const zhongyi = ["#135B36", "#135B363d", "#FFFFFF", "#ffffff"];
const smilingdumplings = ["#A0C73A", "#A0C73A3d", "#A0C73A", "#ffffff"];
const kgalaxyBurwood = ["#A98D68", "#A98D683d", "#A98D68", "#ffffff"];
const lilongchatswood = ["#026952", "#0269523d", "#026952", "#ffffff"];
const takasushi = ["#A98D68", "#A98D683d", "#A98D68", "#ffffff"];
const dumplingco = ["#A98D68", "#A98D683d", "#A98D68", "#ffffff"];
export default {
  hotpotpalace,
  hkyuebaby,
  jiaojiaoxiaoyu,
  dolarshopsydney,
  localhost: kgalaxyBurwood,
  order: dolarshopsydney,
  jackpothotpot,
  test: jackpothotpot,
  lilongchatswood,
  xiaochuanyue: jackpothotpot,
  goodluckhotpot: jackpothotpot,
  zhongyi,
  buffet88ashfield: jackpothotpot,
  spicyworld: jackpothotpot,
  smilingdumplings,
  "kgalaxy-burwood": kgalaxyBurwood,
  takasushi,
  dumplingco,
};
